const navMenuTitles = {
  Provider: 'Proveedor',
  Becas: 'Becas',
  User: 'Usuario',
  ProcesoCompetencia: 'Proceso de Competencia',
  Medicaid: 'Medicaid',
};

export default navMenuTitles;
